import { BaseRequest } from '@/network/requests/BaseRequest'
import { user } from '@/interfaces/user'
import { $in, like } from '../util/QueryBuilder'

export const userRequest = BaseRequest.build<user>('user')

export interface UserSearchParam {
	/**
	 * 用户名
	 */
	name?: string
}

/**
 * 查询用户列表。
 * @param pagesize 分页大小
 * @param page 页码
 * @param where 筛选条件
 */
export function queryUsers(pageSize: number, page: number, where: UserSearchParam) {
	let filter: any = undefined
	console.log('user uery where', where)
	if (where.name) {
		console.log('ddddd')
		filter = {
			account: like(where.name),
		}
	}

	if (filter) {
		console.log('filter', filter)
	}

	return userRequest.queryPage({
		page: page,
		pagesize: pageSize,
		filter: filter,
	})
}
